interface ChoiceButtonProps {
  text: string;
  index: number;
  correctAnswer: number;
  selectedAnswer: number | null;
  onSelect: () => void;
}

export function ChoiceButton({
  text, index, correctAnswer, selectedAnswer, onSelect,
}: ChoiceButtonProps) {
  const isAnswered = selectedAnswer !== null;
  const isSelected = selectedAnswer === index;
  const isCorrect = index === correctAnswer;

  let bg = "#fff";
  let border = "#e0e0e0";
  let badgeBg = "#f0f0f0";
  let badgeColor = "#888";
  let textColor = "#333";

  if (isAnswered) {
    if (isCorrect) {
      bg = "#e8f8ef";
      border = "#2ecc71";
      badgeBg = "#2ecc71";
      badgeColor = "#fff";
      textColor = "#1a7d45";
    } else if (isSelected) {
      bg = "#fde8ec";
      border = "#ff5a7e";
      badgeBg = "#ff5a7e";
      badgeColor = "#fff";
      textColor = "#c41e3a";
    } else {
      bg = "#fafafa";
      border = "#eee";
      textColor = "#bbb";
      badgeBg = "#f0f0f0";
      badgeColor = "#ccc";
    }
  }

  return (
    <button
      onClick={onSelect}
      disabled={isAnswered}
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 12,
        width: "100%",
        padding: "14px 16px",
        textAlign: "left",
        background: bg,
        border: `2px solid ${border}`,
        borderRadius: 8,
        cursor: isAnswered ? "default" : "pointer",
        transition: "all 0.15s",
      }}
    >
      <span style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 28,
        height: 28,
        borderRadius: "50%",
        fontSize: 13,
        fontWeight: 700,
        background: badgeBg,
        color: badgeColor,
        flexShrink: 0,
      }}>
        {isAnswered && isCorrect
          ? "\u2713"
          : isAnswered && isSelected
            ? "\u2717"
            : String.fromCharCode(65 + index)}
      </span>
      <span style={{ fontSize: 14, fontWeight: 500, lineHeight: 1.6, color: textColor, paddingTop: 2 }}>
        {text}
      </span>
    </button>
  );
}
